export default __webpack_public_path__ + "vegan.c914de5b.svg";